// const $ = jQuery.noConflict();

'use strict';

const Helper = {

	addScript: (src, defer = false, onload = null, reload = false) => {
		if(!Helper.isLoadedScript(src) || reload) {
			const script = document.createElement('script');
			script.src = src;
			script.type = 'text/javascript';
			if (defer) {
				script.defer = true;
			}
			if (onload) {
				script.onload = onload;
			}
			document.getElementsByTagName('head')[0].appendChild(script);
		}
	},

	isLoadedScript: (src) => {
		return document.querySelectorAll('[src="' + src + '"]').length > 0;
	},

};

export default Helper;
